import { useTranslation } from 'react-i18next';
import { icons } from '@shared/static/icons';
import { formatTimeRemaining, hasTimeLeft } from '@utils/date-helpers';
import { useCountdownTimer } from '@utils/hooks/useCountdownTimer';

export default function ResendButton({
  expiredAt,
  onResend,
  isLoading = false,
  label,
}) {
  const { t } = useTranslation();
  const timeRemaining = useCountdownTimer(expiredAt);

  const isCooldown = hasTimeLeft(timeRemaining);

  return (
    <div className="resend-button">
      {label && (
        <span className="secondary-text resend-button__label">{label}</span>
      )}
      {isCooldown && (
        <span className="fw-500">{formatTimeRemaining(timeRemaining)}</span>
      )}
      <button
        type="button"
        className="dashed-btn"
        onClick={onResend}
        disabled={isCooldown || isLoading}
      >
        {icons.refresh}
        {isLoading ? t('resending') : t('resend')}
      </button>
    </div>
  );
}
